"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var next_intl_1 = require("next-intl");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ProcessingTotalInfo = function (_a) {
    var fee = _a.fee, totalAmount = _a.totalAmount, currency = _a.currency;
    var t = (0, next_intl_1.useTranslations)('translation');
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.text }, t('processingFee')),
            currency && react_1.default.createElement("div", { className: styles_module_scss_1.default.text }, "".concat(fee, " ").concat(currency))),
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.text }, t('willBeCharged')),
            react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.text, " ").concat(styles_module_scss_1.default.big) }, "".concat(totalAmount, " ").concat(currency)))));
};
exports.default = ProcessingTotalInfo;
